module.exports = __webpack_public_path__ + "img/1457080665.40404fc8.jpg";